import type { SVGProps } from 'react';

export function FootprintIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M9.6 11.7c-.454.791-.907 1.586-1.099 2.7h-5.26c-.353-1.264-.84-3.277-.84-4.8 0-3.6 1.8-8.4 4.8-8.4s3.6 4.485 3.6 6.6c0 1.8-.6 2.85-1.2 3.9m-6 6.3v-1.8h4.8V18c0 1.324-1.076 2.4-2.4 2.4A2.4 2.4 0 0 1 3.6 18m10.8-3.9c-.6-1.05-1.2-2.1-1.2-3.9 0-2.115.6-6.6 3.6-6.6s4.8 4.8 4.8 8.4c0 1.519-.487 3.536-.84 4.8H15.5c-.195-1.114-.649-1.909-1.103-2.7zm6 6.3c0 1.324-1.076 2.4-2.4 2.4a2.4 2.4 0 0 1-2.4-2.4v-1.8h4.8z" />
    </svg>
  );
}
